import React, { useEffect, useState } from 'react';
import { Image, Platform } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import Login from './Login';
import ProfileScreen from './ProfileScreen';
import Bookings from './Bookings';
import AddAddress from './screens/Book/AddAddress';
import Invoices from './Invoices';
import FamilyScreen from './FamilyScreen';
import ManageFamilyScreen from './ManageFamilyScreen';
import BookingDetails from './BookingDetails';
import BookingCalendar from './BookingCalendar';
import Recurring from './Recurring';
import ProfilePage from './ProfilePage';
import RecurringDetails from './RecurringDetails';
import CreateAccount from './Signup';
import SelectKidScreen from './screens/Book/SelectKidScreen';
import SelectKidScreen1 from './screens/Book/SelectKidScreen1';
import AddNewKidScreen from './screens/Book/AddNewKidSceen';
import ScheduleService from './screens/Book/ScheduleService';
import SelectAddressScreen from './screens/Book/SelectAddressScreen';
import SelectDaysScreen from './screens/Book/SelectDaysScreen';
import Notification from './Notification';
import SeeAllPlans from './screens/Book/SeeAllPlans'
import ConfirmBooking from './screens/Book/ConfirmBooking';
import AddressScreen from './screens/Book/AddressScreen';
import SelectTransport from './screens/Book/SelectTransport';
import { useDispatch, useSelector } from 'react-redux';
import Profilebookings from './ViewInvoice';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { loginActions } from './slices/authSlice';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import Events from './screens/Events/Events';
import EventDetails from './screens/Events/EventDetails';
import ProfileEventsList from './screens/Events/ProfileEventsList';
import ProfileEventDetails from './screens/Events/ProfileEventDetails';
import { useNavigation } from '@react-navigation/native';
import DocumentsList from './DocumentsList';
import ChatWebView from './ChatWebView';
import { toast } from 'react-toastify';
import { updateFamilyApi } from './apiCalls/LoginApi';

const Stack = createNativeStackNavigator();
const Tab = createBottomTabNavigator();

// Stack Navigators for specific sections
function BookingsListStackNavigator() {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name="DetailsTab" component={Bookings} />
      <Stack.Screen name="Recurring" component={Recurring} />
      <Stack.Screen name="RecurringDetails" component={RecurringDetails} />
      <Stack.Screen name="Profilebookings" component={Profilebookings} />
      <Stack.Screen name="BookingDetails" component={BookingDetails} />
      <Stack.Screen name="BookingCalendar" component={BookingCalendar} />
      <Stack.Screen name="Notification" component={Notification} />
      <Stack.Screen name="ChatWebView" component={ChatWebView} />
    </Stack.Navigator>
  );
}


function ProfileStackNavigator() {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name="ProfileScreen" component={ProfileScreen} />
      <Stack.Screen name="ProfilePage" component={ProfilePage} />
      <Stack.Screen name="Invoices" component={Invoices} />
      <Stack.Screen name="Family" component={FamilyScreen} />
      <Stack.Screen name="ManageFamily" component={ManageFamilyScreen} />
      <Stack.Screen name="Profilebookings" component={Profilebookings} />
      <Stack.Screen name="SelectKidScreen1" component={SelectKidScreen1} />
      <Stack.Screen name="AddNewKidScreen" component={AddNewKidScreen} />
      <Stack.Screen name="RecurringDetails" component={RecurringDetails} />
      <Stack.Screen name="BookingDetails" component={BookingDetails} />
      <Stack.Screen name="Notification" component={Notification} />
      <Stack.Screen name="AddressScreen" component={AddressScreen} />
      <Stack.Screen name="AddAddress" component={AddAddress} />
      <Stack.Screen name="DocumentsList" component={DocumentsList} />
      <Stack.Screen name="ChatWebView" component={ChatWebView} />
    </Stack.Navigator>
  );
}

function ScheduleNavigator() {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name="ScheduleService" component={ScheduleService} />
      <Stack.Screen name="Camps" component={Events} />
      <Stack.Screen name="EventDetails" component={EventDetails} />
      <Stack.Screen name="ProfileEventsList" component={ProfileEventsList} />
      <Stack.Screen name="ProfileEventDetails" component={ProfileEventDetails} />
      <Stack.Screen name="SelectKidScreen" component={SelectKidScreen} />
      <Stack.Screen name="AddNewKidScreen" component={AddNewKidScreen} />
      <Stack.Screen name="SelectAddressScreen" component={SelectAddressScreen} />
      <Stack.Screen name="AddAddress" component={AddAddress} />
      <Stack.Screen name="Notification" component={Notification} />
      <Stack.Screen name="BookingDetails" component={BookingDetails} />
      <Stack.Screen name="Profilebookings" component={Profilebookings} />
      <Stack.Screen name="RecurringDetails" component={RecurringDetails} />
      <Stack.Screen name="SeeAllPlans" component={SeeAllPlans} />
      <Stack.Screen name="SelectDaysScreen" component={SelectDaysScreen} />
      <Stack.Screen name="ConfirmBooking" component={ConfirmBooking} />
      <Stack.Screen name='SelectTransport' component={SelectTransport} />
      <Stack.Screen name="ChatWebView" component={ChatWebView} />
    </Stack.Navigator>
  );
}

function LoginNavigator() {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name="Login" component={Login} />
      <Stack.Screen name="CreateAccount" component={CreateAccount} />
    </Stack.Navigator>
  );
}

// Bottom Tab Navigator for authenticated users
function BottomTabNavigator() {
  const userType = useSelector((state) => state.auth.userType);

  return (
    <Tab.Navigator
      initialRouteName="Book"
      screenOptions={({ route }) => ({
        tabBarIcon: ({ focused }) => {
          let imageSource;
          if (route.name === 'Book') {
            imageSource = focused
              ? require('./assets/bottomNavigationIcons/bookPink.png')
              : require('./assets/bottomNavigationIcons/bookIconGrey.png');
          } else if (route.name === 'DetailsTab') {
            const isAdmin = userType === 'admin' || userType === '"admin"';
            if (isAdmin) {
              imageSource = require('./assets/Lock.png');
            } else {
              imageSource = focused
                ? require('./assets/bottomNavigationIcons/detailsIconPink.png')
                : require('./assets/bottomNavigationIcons/detailsconGrey.png');
            }
          } else if (route.name === 'ProfileTab') {
            imageSource = focused
              ? require('./assets/bottomNavigationIcons/profileIconPink.png')
              : require('./assets/bottomNavigationIcons/ProfileIconGrey.png');
          }
          return (
            <Image
              source={imageSource}
              style={{ width: '200%', height: '120%' }}
              resizeMode="contain"
            />
          );
        },
        tabBarStyle: {
          height: 70,
          paddingBottom: 15,
          paddingTop: 5,
          backgroundColor: 'white',
        },
        tabBarHideOnKeyboard: true,
        tabBarShowLabel: false,
        headerShown: false,
      })}
    >
      <Tab.Screen name="Book" component={ScheduleNavigator} />
      <Tab.Screen
        name="DetailsTab"
        component={BookingsListStackNavigator}
        listeners={{
          tabPress: (e) => {
            const isAdmin = userType === 'admin' || userType === '"admin"';
            if (isAdmin) {
              e.preventDefault();
            }
          },
        }}
      />
      <Tab.Screen name="ProfileTab" component={ProfileStackNavigator} />
    </Tab.Navigator>
  );
}


export default () => {
  const token = useSelector(state => state.auth.token);
  const redirectTo = useSelector(state => state.auth.redirectTo);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const dispatch = useDispatch();
  // const navigation = useNavigation();
  const userType = useSelector(state => state.auth.userType);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const storedToken = await AsyncStorage.getItem('token');
        const storedUserType = await AsyncStorage.getItem('userType');
        const storedUserID = await AsyncStorage.getItem('userId');
        if (storedToken) {
          dispatch(loginActions.setToken(storedToken));
          dispatch(loginActions.setuserType(storedUserType));
          dispatch(loginActions.setuserId(storedUserID));
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Error retrieving token from AsyncStorage:', error);
      }
    };

    checkAuth();
  }, [dispatch, token, userType]);

  useEffect(() => {

    // sessionStorage only exists on web
    const pendingToken =
      Platform.OS === 'web' ? sessionStorage.getItem('pendingToken') : null;
    if (!isAuthenticated || Platform.OS !== 'web') {
      if (pendingToken) {
        toast.warn("Please login/signup to join the family")
      }
      return;
    }
    if (!pendingToken) {
      return;
    }

    const processPendingToken = async () => {
      console.log('Token from URL:', pendingToken);
      sessionStorage.removeItem('pendingToken');

      const url = new URL(window.location.href);
      url.searchParams.delete('token');
      window.history.replaceState({}, '', url.toString());

      try {
        const res = await updateFamilyApi(pendingToken);
        if (res.Success) {
          toast.success('You have been added to the family successfully' || res?.Message);
        } else {
          toast.error(res?.Message || 'Failed to update family');
        }
      } catch (error) {
        toast.error(error?.Message || 'Failed to update family');
      }
    };

    processPendingToken();
  }, [isAuthenticated]);

  // This can be removed later
  // useEffect(() => {
  //   if (token) {
  //     setIsAuthenticated(true);
  //   } else {
  //     setIsAuthenticated(false);
  //   }
  // }, [token]);

  // Handle redirect after login
  // useEffect(() => {
  //   console.log("redirectTo is", redirectTo);
  //   if (redirectTo && isAuthenticated) {
  //     if (redirectTo === 'EventDetails') {
  //       navigation.navigate('Book', { screen: 'Events', params: { screen: 'EventDetails' } });
  //     }
  //     dispatch(loginActions.clearRedirectTo());
  //   }
  // }, [redirectTo, isAuthenticated, navigation, dispatch]);

  return (
    <SafeAreaProvider>
      <NavigationContainer documentTitle={{ formatter: () => "Danilee's Helping Hands" }}>
        <Stack.Navigator screenOptions={{ headerShown: false }}>
          {isAuthenticated ? (
            <Stack.Screen name="Book" component={BottomTabNavigator} />
          ) : (
            <Stack.Screen name="LoginSignup" component={LoginNavigator} />
          )}
        </Stack.Navigator>
      </NavigationContainer>
    </SafeAreaProvider>
  );
};
